import { render, staticRenderFns } from "./website-subdomain-detail.vue?vue&type=template&id=b555d9fc&scoped=true&"
import script from "./website-subdomain-detail.vue?vue&type=script&lang=js&"
export * from "./website-subdomain-detail.vue?vue&type=script&lang=js&"
import style0 from "./website-subdomain-detail.vue?vue&type=style&index=0&id=b555d9fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b555d9fc",
  null
  
)

export default component.exports